import moment from "@evercam/shared/plugins/moment"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(moment)
